import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import DropzoneComponent from 'react-dropzone-component';
import { setLoaderComplete, setLoaderStart } from '../../../../actions/loader/loader';
import showToaster from '../../../../helpers/toastrMessgaes/showToaster';
import profileEditIcon from '/public/profileUploadLogo.svg';

function Dropzone(props) {
    const {
        className,
        componentConfig,
        loaderName,
        fieldName,
        formName,
        handleDropzone,
        isLoader,
        maxUploadSize,
        setLoaderStart,
        setLoaderComplete,
        inputContainer
    } = props;

    const dropzoneRef = useRef(null);

    useEffect(() => {
        const isBrowser = typeof window !== 'undefined';
        const isDocument = typeof document !== 'undefined';
        if (isBrowser && isDocument) {
            const hiddenInput = document.querySelector(".dz-hidden-input");
            if (hiddenInput) {
                hiddenInput.style.visibility = 'visible';
                hiddenInput.style.opacity = '0';
                hiddenInput.style.cursor = 'pointer';
            }
        }
    }, []);

    const success = async (file, fromServer) => {
        const fileName = fromServer.fileName;
        setLoaderStart(loaderName)
        await handleDropzone(fileName, fieldName, formName);
        if (isLoader) setLoaderComplete(loaderName);
        if (dropzoneRef.current) {
            dropzoneRef.current.removeFile(file);
        }
    }

    const error = (file) => {
        if (file?.size > (1024 * 1024 * parseInt(maxUploadSize))) {
            showToaster({ messageId: 'limitError', requestContent: maxUploadSize, toasterType: 'error' })
            if (dropzoneRef.current) {
                dropzoneRef.current.removeFile(file);
            }
            if (isLoader) setLoaderComplete(loaderName);
            return;
        }
    }

    const addedFile = async (file) => {
        let fileTypes = fieldName === 'favicon' ? ['image/png'] : ['image/jpeg', 'image/png', 'image/jpg'];
        let isOnline = typeof window !== 'undefined' && window.navigator.onLine;

        if (isLoader) setLoaderStart(loaderName);

        if (!isOnline) {
            showToaster({ messageId: 'networkFailed', toasterType: 'error' })
            if (dropzoneRef.current) {
                dropzoneRef.current.removeFile(file);
            }
            if (isLoader) setLoaderComplete(loaderName);
            return;
        }

        if (file?.size > (1024 * 1024 * parseInt(maxUploadSize))) {
            showToaster({ messageId: 'limitError', requestContent: maxUploadSize, toasterType: 'error' })
            if (dropzoneRef.current) {
                dropzoneRef.current.removeFile(file);
            }
            if (isLoader) setLoaderComplete(loaderName);
            return;
        }

        if (file && !fileTypes.includes(file.type)) {
            if (dropzoneRef.current) {
                dropzoneRef.current.removeFile(file);
            }
            showToaster({ messageId: 'filetypeError', toasterType: 'error' })
            if (isLoader) setLoaderComplete(loaderName);
            return;
        }
    }

    const acceptedFiles = fieldName === 'favicon' ? 'image/png' : 'image/jpeg, image/png, image/jpg';

    const djsConfig = {
        dictDefaultMessage: '',
        addRemoveLinks: false,
        uploadMultiple: false,
        maxFilesize: parseInt(maxUploadSize),
        acceptedFiles,
        dictMaxFilesExceeded: 'Remove the existing image and try upload again',
        previewsContainer: false,
        hiddenInputContainer: inputContainer,
        timeout: 300000,
        maxFiles: 1
    };

    const eventHandlers = {
        init: dz => dropzoneRef.current = dz,
        success: success,
        addedFile: addedFile,
        error: error
    };

    return (
        <div className={className}>
            <DropzoneComponent
                config={componentConfig}
                eventHandlers={eventHandlers}
                djsConfig={djsConfig}
            >
                <img src={profileEditIcon} className={"profileEditIcon"} alt="Upload icon" />
            </DropzoneComponent>
        </div>
    )
}

const mapState = state => ({
    maxUploadSize: state?.siteSettings?.data?.maxUploadSize,
});

const mapDispatch = {
    setLoaderStart,
    setLoaderComplete
};

export default withStyles()(connect(mapState, mapDispatch)(Dropzone));